import { supabase } from '@/lib/supabase/supabaseClient';
import { GetQuestionBankQuestionsProps } from '.';
import { getOrganizationById } from '@/features/organization/hooks/useQuery/useGetOrganizationById/useGetOrganizationById.query';

export const getQuestionBankQuestions = async ({
  crmSystem,
  organisationId,
  search,
}: GetQuestionBankQuestionsProps) => {
  const systems = Array.isArray(crmSystem) ? crmSystem : [crmSystem];
  const orgData = await getOrganizationById(organisationId);

  let query = supabase
    .from('question_bank')
    .select(`*`)
    .order('created_at', { ascending: true })
    .eq('organisation_id', organisationId)
    .in('crm_system', systems.filter(system => orgData.crm_connections?.includes(system)));

  if (search) {
    query = query.textSearch('question', search, {
      type: 'plain',
    });
  }

  return await query.throwOnError().then((res) => res.data);
};
